import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reduceTooltipInfo } from '../../actions/policy/reduceTooltipInfo';

export function* getTooltipInfoSaga({ payload }) {
    try {
        yield put(reduceLoading({ code: 'getTooltipInfo', value: true }));
        const session = yield getSessionSaga();
        const response = yield call(fetch, `/api/product/${payload}/tooltip/`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });
        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));
        if (!result.operation?.status) {
            yield put(reduceLoading({ code: 'getTooltipInfo', value: false }));
            return;
        }
        yield put(reduceTooltipInfo({ pages: result.pages }));
        yield put(reduceLoading({ code: 'getTooltipInfo', value: false }));
    } catch (error) {
        console.log('Error while calling Get Tooltip Information API - ', error);
        yield put(reduceLoading({ code: 'getTooltipInfo', value: false }));
    }
}
